import { ShortProfile } from '@apps/auth/domain/models';
import { Copil } from './copil';

export class DetailedCopil extends Copil
{
    public governorProfile: ShortProfile;

    constructor (private shortProfile: ShortProfile)
    {
        super();

        this.governorProfile = this.shortProfile;
    }
}
